// extracted by mini-css-extract-plugin
module.exports = {"live":"Live_live_8pJ5M","detail":"Live_detail_uGx3C","liveBtn":"Live_liveBtn_1Pj2T","active":"Live_active_1PcwS"};